import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseUtils, FuseAnimate} from '@fuse';
import {bindActionCreators} from 'redux';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import ReactTable from "react-table";
import {MenuItem, Select, Typography} from '@material-ui/core';
import moment from "moment";

const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {}

});

class UseRecordList extends Component {

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    render() {
        const {searchText, sidebarSearchText, useRecords, setSidebarSearchText} = this.props;

        const data = this.getFilteredArray(useRecords, searchText);

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有使用紀錄
                    </Typography>
                </div>
            );
        }

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    filterable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有使用紀錄"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    defaultPageSize={10}
                    className='-striped'
                    data={
                        data.sort(function (preUseRecord, currUseRecord) {
                            return currUseRecord.id - preUseRecord.id;
                        })
                    }
                    columns={[
                        {
                            Header: "時間",
                            accessor: "date",
                            filterable: true,
                            className: "justify-center",
                            Cell: row => {
                                return (row.value) ? moment(row.value).format('YYYY-MM-DD hh:mm:ss') : '';
                            },
                        },
                        {
                            Header: "項目",
                            accessor: "type",
                            filterable: true,
                            className: "justify-center",
                        },
                        {
                            Header: "服務類型",
                            accessor: "mission_price_type.name",
                            filterable: true,
                            className: "justify-center",
                        },
                        {
                            Header: "附註",
                            accessor: "comment",
                            filterable: true,
                            className: "justify-center",
                        },
                        {
                            Header: "加減點數",
                            accessor: "points",
                            className: "justify-center",
                            filterMethod: (filter, row) => {
                                const points = row._original.points;
                                if (filter.value === "only_add") {
                                    return parseInt(points, 10) > 0;
                                } else if (filter.value === "only_minus") {
                                    return parseInt(points, 10) < 0;
                                } else {
                                    return true;
                                }
                            },
                            Filter: ({filter, onChange}) => {

                                if (sidebarSearchText && !filter) {
                                    onChange(sidebarSearchText)
                                }

                                if (sidebarSearchText && filter && sidebarSearchText !== filter.value) {
                                    onChange(sidebarSearchText)
                                }

                                return (
                                    <Select
                                        value={filter ? filter.value : "all"}
                                        style={{width: '100%'}}
                                        onChange={event => {
                                            onChange(event.target.value);
                                            if (sidebarSearchText) setSidebarSearchText({target: {value: null}});
                                        }}
                                        name='selectAddMinus'
                                    >
                                        <MenuItem value='all'>顯示全部</MenuItem>
                                        <MenuItem value='only_add'>只顯示加點</MenuItem>
                                        <MenuItem value='only_minus'>只顯示扣點</MenuItem>
                                    </Select>
                                );
                            }
                        },
                    ]}
                />
            </FuseAnimate>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getGroup: ReduxGroup.ActionCreator.getGroup,
        deleteGroup: ReduxGroup.ActionCreator.deleteGroup,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openEditDataDialog: ReduxGlobal.ActionCreator.openEditDataDialog,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openSecondDataDialog: ReduxGlobal.ActionCreator.openSecondDataDialog,
        setSidebarSearchText: ReduxGlobal.ActionCreator.setSidebarSearchText,
    }, dispatch);
}

function mapStateToProps({group: {groups}, useRecord, global: {searchText, sidebarSearchText}}) {
    return {groups, searchText, sidebarSearchText, useRecords: useRecord.list};
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(UseRecordList)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/UseRecordList.js